/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState } from "react"
import { Plane, useGLTF, useVideoTexture, useCursor } from "@react-three/drei"
import TextComponent from "./TextComponent"

export function VideoComponent(props) {
  const texture = useVideoTexture(props.vid)

  // component called OverlayMesh that returns a plane with a 0.5 opacity
  const OverlayMesh = ({ txt, url }) => {
    const [Hovered, setHovered] = useState(false)
    useCursor(Hovered /*'pointer', 'auto'*/)

    const openTab = () => {
      window.open(url, "_blank")
    }

    return (
      <group
        onPointerEnter={() => setHovered(true)}
        onPointerOut={() => setHovered(false)}
        onPointerDown={() => {
          openTab()
        }}>
        <>
          <Plane args={[2, 1, 1]} position={txt == "artisocial" ? [0, 0, 0.2] : [0, 0, 0.01]} rotation={props.rotation} scale={props.scale}>
            <meshBasicMaterial toneMapped={false} transparent opacity={Hovered ? 0 : 0.8} color={"#000000"} />
          </Plane>
          {!Hovered && <TextComponent txt={txt} position={txt == "artisocial" ? [0, 0, 0.2] : [0, 0, 0.1]} weight={"light"} />}
        </>
      </group>
    )
  }

  return (
    // <group {...props} dispose={null}>
    <group>
      {!props.isVideogame && <OverlayMesh txt={props.title} url={props.url} />}
      <mesh scale={props.scale} position={props.position} rotation={props.rotation}>
        <planeGeometry args={[2, 1, 1]} />
        <meshBasicMaterial map={texture} />
      </mesh>
    </group>
  )
}
